<div id="orders" class="page-layout carded fullwidth">
    <div class="top-bg primary"></div>
    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="header primary" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-xs="row"
            fxLayoutGap="20px" fxLayoutAlign.gt-xs="space-between center">

            <!-- APP TITLE -->
            <div class="mat-display-1 my-0 my-sm-24 welcome-message" fxLayout="row" fxLayoutAlign="start center">
                <span [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">{{'DEVICE_DATA_LIST' |
                    translate}}</span>
            </div>
            <!-- / APP TITLE -->
            <div class="search-wrapper  ml-sm-32">
                <div class="search" fxFlex fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon>search</mat-icon>
                    <input #filter [(ngModel)]="filterText" placeholder="{{'SEARCH' | translate}}">
                </div>
            </div>
            <div class="row">
            </div>
        </div>
        <!-- / HEADER -->
        <div class="content-card my-16" style="justify-content: space-between;">
            <div class="p-20">
                <mat-table class="orders-table" style="border-radius: 10px 10px 0px 0px; overflow: auto;" #table
                    [dataSource]="dataSource" matSort  matSortActive="sonBaglantiTarih"
                    matSortDirection="desc" fusePerfectScrollbar>

                    <!-- Device ID Column -->
                    <ng-container matColumnDef="deviceId">
                        <mat-header-cell  *matHeaderCellDef mat-sort-header>
                            <span class="mr-8">Cihaz Id</span>
                            <mat-icon matTooltip="Cihazın Id'si">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell  *matCellDef="let element">
                            {{element.id!=null?element.id:'---'}}
                        </mat-cell>
                    </ng-container>

                    <!-- Firmware Column -->
                    <ng-container matColumnDef="firmware">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span class="mr-8">Firmware</span>
                            <mat-icon matTooltip="Cihazın içindeki firmware">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.deviceLatestStatus!=null?(element.deviceLatestStatus?.firmware!=null?element.deviceLatestStatus?.firmware:'---'):'---'}}
                        </mat-cell>
                    </ng-container>

                    <!-- latitude Column -->
                    <ng-container matColumnDef="gpS_Enlem">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span class="mr-8">{{'LATITUDE'|translate}}</span>
                            <mat-icon matTooltip="Cihazdan gelen gps enlem bilgisi">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.deviceLatestStatus!=null?(element.deviceLatestStatus?.gpS_Enlem!=null?element.deviceLatestStatus?.gpS_Enlem:'---'):'---'}}
                        </mat-cell>
                    </ng-container>

                    <!-- longitude Column -->
                    <ng-container matColumnDef="gpS_Boylam">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span class="mr-8">{{'LONGITUDE'|translate}}</span>
                            <mat-icon matTooltip="Cihazdan gelen gps boylam bilgisi">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.deviceLatestStatus!=null?(element.deviceLatestStatus?.gpS_Boylam!=null?element.deviceLatestStatus?.gpS_Boylam:'---'):'---'}}
                        </mat-cell>
                    </ng-container>

                    <!-- GF Column -->
                    <ng-container matColumnDef="gpS_Fix">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span class="mr-8">{{'GPS_FIX'|translate}}</span>
                            <mat-icon matTooltip="Cihazın gps verisini doğrulama seviyesi. (0:Çok Kötü, 1:Kötü, 2:İyi)">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.deviceLatestStatus!=null?(element.deviceLatestStatus?.gpS_Fix!=null?element.deviceLatestStatus?.gpS_Fix:'---'):'---'}}
                        </mat-cell>
                    </ng-container>

                    <!-- GS Column -->
                    <ng-container matColumnDef="gpS_UyduSayisi">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span class="mr-8">{{'NUMBER_OF_GPS_SATELLITES'|translate}}</span>
                            <mat-icon matTooltip="Cihazın gps uydu sayısı">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.deviceLatestStatus!=null?(element.deviceLatestStatus?.gpS_UyduSayisi!=null?element.deviceLatestStatus?.gpS_UyduSayisi:'---'):'---'}}
                        </mat-cell>
                    </ng-container>

                    <!-- GR Column -->
                    <ng-container matColumnDef="gpS_DinlemeSayisi">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span class="mr-8">{{'NUMBER_OF_GPS_LISTENING'|translate}}</span>
                            <mat-icon matTooltip="Cihaz gps verisini alabilmek için yaptığı deneme sayısı">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.deviceLatestStatus!=null?(element.deviceLatestStatus?.gpS_DinlemeSayisi!=null?element.deviceLatestStatus?.gpS_DinlemeSayisi:'---'):'---'}}
                        </mat-cell>
                    </ng-container>

                    <!-- ALT Column -->
                    <ng-container matColumnDef="gpS_Rakim">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span class="mr-8">{{'GPS_ALTITUDE'|translate}}</span> 
                            <mat-icon matTooltip="Cihazın ölçtüğü rakım bilgisi">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.deviceLatestStatus!=null?(element.deviceLatestStatus?.gpS_Rakim!=null?element.deviceLatestStatus?.gpS_Rakim:'---'):'---'}}
                        </mat-cell>
                    </ng-container>
                    <!-- Solar Voltaj Column -->
                    <ng-container matColumnDef="solarEnerjiVoltaj">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span class="mr-8">{{'SOLAR_VOLTAGE'|translate}}</span>
                            <mat-icon matTooltip="Cihazın güneş enerjisi seviyesi">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.deviceLatestStatus!=null?(element.deviceLatestStatus?.solarEnerjiVoltaj!=null?element.deviceLatestStatus?.solarEnerjiVoltaj:'---'):'---'}}
                        </mat-cell>
                    </ng-container>
                    <!-- Battery Column -->
                    <ng-container matColumnDef="batarya">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span class="mr-8">{{'BATTERY'|translate}}</span>
                            <mat-icon matTooltip="Cihazın pil seviyesi">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.deviceLatestStatus!=null?(element.deviceLatestStatus?.batarya!=null?element.deviceLatestStatus?.batarya:'---'):'---'}}
                        </mat-cell>
                    </ng-container>
                    <!-- CPU heat Column -->
                    <ng-container matColumnDef="cpuSicaklik">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span class="mr-8">{{'CPU_HEAT'|translate}}</span>
                            <mat-icon matTooltip="Cihazın sıcaklık değeri">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.deviceLatestStatus!=null?(element.deviceLatestStatus?.cpuSicaklik!=null?element.deviceLatestStatus?.cpuSicaklik:'---'):'---'}}
                        </mat-cell>
                    </ng-container>
                    <!-- GSM Level Column -->
                    <ng-container matColumnDef="gsM_Sinyal">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span class="mr-8">GSM Level</span>
                            <mat-icon matTooltip="Cihazın gsm sinyalinin seviyesi">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.deviceLatestStatus!=null?(element.deviceLatestStatus?.gsM_Sinyal!=null?element.deviceLatestStatus?.gsM_Sinyal:'---'):'---'}}
                        </mat-cell>
                    </ng-container>
                    <!-- PTime Column -->
                    <ng-container matColumnDef="acikKalmaSuresi">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span class="mr-8">PTime</span>
                            <mat-icon matTooltip="Cihazın uyandıktan sonra açık kalma süresi">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.deviceLatestStatus!=null?(element.deviceLatestStatus?.acikKalmaSuresi!=null?element.deviceLatestStatus?.acikKalmaSuresi:'---'):'---'}}
                        </mat-cell>
                    </ng-container>
                    <!-- GCTime Column -->
                    <ng-container matColumnDef="gsM_BaglantiSuresi">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span class="mr-8">GCTime</span>
                            <mat-icon matTooltip="Cihazın gsm bağlantı süresi">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.deviceLatestStatus!=null?(element.deviceLatestStatus?.gsM_BaglantiSuresi!=null?element.deviceLatestStatus?.gsM_BaglantiSuresi:'---'):'---'}}
                        </mat-cell>
                    </ng-container>
                    <!-- Doluluk Column -->
                    <ng-container matColumnDef="mesafe">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span class="mr-8">{{'DISTANCE'|translate}}</span>
                            <mat-icon matTooltip="Cihazın ölçmüş olduğu yükseklik verisi">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.deviceLatestStatus!=null?(element.deviceLatestStatus?.mesafe!=null?element.deviceLatestStatus?.mesafe:'---'):'---'}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="alarmType">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span class="mr-8">{{'ALARM_TYPE'|translate}}</span>
                            <mat-icon matTooltip="Cihazın uyanma türü">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let device">
                            {{(device.alarmType|AlarmTypePipe)|translate}}
                        </mat-cell>
                    </ng-container>

                    <!-- B. cou Column -->
                    <ng-container matColumnDef="yetersizBataryaUyanamamaCount">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span class="mr-8">{{'NUMBER_OF_LOW_BATTERY_ERRORS'|translate}}</span>
                            <mat-icon matTooltip="Cihazın bataryasının zayıf olmasından dolayı uyanamama sayısı">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.deviceLatestStatus!=null?(element.deviceLatestStatus?.yetersizBataryaUyanamamaCount!=null?element.deviceLatestStatus?.yetersizBataryaUyanamamaCount:'---'):'---'}}
                        </mat-cell>
                    </ng-container>
                    <!-- GSM cou Column -->
                    <ng-container matColumnDef="gsM_SinyaliYakalayamamaCount">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span class="mr-8">{{'NUMBER_OF_FAILURES_TO_CAPTURE_SIGNAL'|translate}}</span>
                            <mat-icon matTooltip="Cihazdan gsm sinyalini yakalayamama uyarı sayısı">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.deviceLatestStatus!=null?(element.deviceLatestStatus?.gsM_SinyaliYakalayamamaCount!=null?element.deviceLatestStatus?.gsM_SinyaliYakalayamamaCount:'---'):'---'}}
                        </mat-cell>
                    </ng-container>
                    <!-- GPS cou Column -->
                    <ng-container matColumnDef="gpS_VerisiFixleyememeCount">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span class="mr-8">{{'NUMBER_OF_GPS_VERIFICATION_FAILS'|translate}}</span>
                            <mat-icon matTooltip="Cihazın gps bilgisini doğrulayamama uyarı sayısı">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.deviceLatestStatus!=null?(element.deviceLatestStatus?.gpS_VerisiFixleyememeCount!=null?element.deviceLatestStatus?.gpS_VerisiFixleyememeCount:'---'):'---'}}
                        </mat-cell>
                    </ng-container>
                    <!-- Req. Cou Column -->
                    <ng-container matColumnDef="sunucuHaberlesememeCount">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span class="mr-8">{{'NUMBER_OF_SERVER_COMMUNICATION_ERRORS'|translate}}</span>
                            <mat-icon matTooltip="Cihazın sunucu ile haberleşememesinden oluşan uyarının sayısı">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.deviceLatestStatus!=null?(element.deviceLatestStatus?.sunucuHaberlesememeCount!=null?element.deviceLatestStatus?.sunucuHaberlesememeCount:'---'):'---'}}
                        </mat-cell>
                    </ng-container>
                    <!-- Per. Cou Column -->
                    <ng-container matColumnDef="maxUyaniklikSuresiAsmaCount">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span class="mr-8">{{'WAKE_TIME_COUNT'|translate}}</span>
                            <mat-icon matTooltip="Cihaz uyanma süresini aşmasından dolayı oluşan uyarının sayısı">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.deviceLatestStatus!=null?(element.deviceLatestStatus?.maxUyaniklikSuresiAsmaCount!=null?element.deviceLatestStatus?.maxUyaniklikSuresiAsmaCount:'---'):'---'}}
                        </mat-cell>
                    </ng-container>
                    <!-- date Column -->
                    <ng-container matColumnDef="sonBaglantiTarih">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span class="mr-8">{{'DATE'|translate}}</span>
                            <mat-icon matTooltip="Cihazdan gelen verinin zaman bilgisi">error_outline</mat-icon>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.deviceLatestStatus!=null?(element.deviceLatestStatus?.sonBaglantiTarih!=null?(element.deviceLatestStatus?.sonBaglantiTarih | date:'dd/MM/y HH:mm'):'---'):'---'}}
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                    <mat-row *matRowDef="let element columns: displayedColumns;" class="order" matRipple>
                    </mat-row>
                </mat-table>
                <mat-paginator #paginator [length]="paginator.length" [pageSize]="10" [pageSizeOptions]="[10, 50, 100]">
                </mat-paginator>
            </div>
        </div>
    </div>
    <!-- / CENTER -->
</div>